import { render, staticRenderFns } from "./PixFinalize.vue?vue&type=template&id=70d8c3d4&scoped=true"
import script from "./PixFinalize.vue?vue&type=script&lang=js"
export * from "./PixFinalize.vue?vue&type=script&lang=js"
import style0 from "./PixFinalize.vue?vue&type=style&index=0&id=70d8c3d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d8c3d4",
  null
  
)

export default component.exports